import type { IconData } from '@stacksjs/iconify-core'

export const porkMeat: IconData = {
  "body": "<g fill=\"none\" stroke=\"#2859c5\" stroke-linecap=\"round\" stroke-linejoin=\"round\" stroke-width=\"3\"><path fill=\"#8fbffa\" d=\"M5.881 3.142c-.941.14-1.796.682-2.158 1.545c-1.536 3.653-.356 10.017 1.055 15.627C3.04 23.486 2 27.114 2 31c0 2.714 0 15 22 15s22-12.286 22-15c0-3.887-1.04-7.514-2.778-10.686c1.41-5.61 2.591-11.974 1.055-15.627c-.362-.863-1.217-1.406-2.158-1.545c-5.336-.792-10.172 1.835-13.866 5.386A18 18 0 0 0 24 8a18 18 0 0 0-4.253.528c-3.694-3.551-8.53-6.178-13.866-5.386\"/><path d=\"M32 21v1m-16-1v1\"/><path fill=\"#fff\" d=\"M24 40c-4.781 0-9-1.625-9-6.19c0-.929 0-6.81 9-6.81s9 5.881 9 6.81c0 4.565-4.219 6.19-9 6.19\"/><path d=\"M27 33v1m-6-1v1\"/></g>",
  "width": 48,
  "height": 48,
  "viewBox": "0 0 48 48"
}

export default porkMeat
